<script lang="ts">
    import {pipe} from '../../../../svelte/utils';
    import {loc} from '../../../../svelte/pipes';
    import type {Labeled} from '../../../../typings/portaro.be.types';

    export let option: Labeled;
</script>

<template>
    {pipe(option, loc())}
</template>